import * as actionTypes from './actionTypes'
import {
    fetchWithCookieRefresh, handleResponseError,
} from '../../../utils'

import { message } from 'antd'


export const setImageData = (data) => ({
    type: actionTypes.SET_IMAGE_DATA,
    data: data,
})

export const setSearchTime = (value) => ({
    type: actionTypes.SET_SEARCH_TIME,
    value: value,
})

export const imageSearchSimilar = (formData) => {
    return (dispatch, getState) => {
        return fetchWithCookieRefresh('/api/image_search/similar_search', {
            method: 'POST',
            body: formData,
        })
        .then(data => {
            console.log("/api/image_search/similar_search data = ", data);
            dispatch(setImageData(data.data?.data ? data.data?.data : []))
            dispatch(setSearchTime(data.data?.search_time ? data.data?.search_time : 0))
            return true
        })
        .catch(error => {
            handleResponseError(message, error)
        })
    }
}
